import * as styles from "./SponsorDogPromoCardFlat.module.scss";

import React from "react";

import CurvedBorderVertical from "../../../../components/borders/CurvedBorderVertical";
import { Button } from "../../../../components/common";
import { HeartOffset } from "../../../../components/common/Icons";
import ProcessedImage from "../../../../components/common/ProcessedImage/ProcessedImage";
import label from "../../../../static/img/shape_card_label.svg";
import { Colours } from "../../../../utils/colours";

export interface SponsorDogPromoCardFlatProps {
	imgSrc: string;
	imgAlt: string;
	text: string;
	url: string;
}
export const SponsorDogPromoCardFlat: React.FC<
	SponsorDogPromoCardFlatProps
> = ({ imgSrc, imgAlt, text, url }) => {
	return (
		<article className={styles.sponsordogpromocontainer}>
			<div className={styles.label}>
				<img
					aria-hidden="true"
					width={137}
					height={35}
					src={label}
					alt=""
					loading={"lazy"}
				/>
				<span className={styles.labeltext}>Sponsor Me</span>
			</div>
			<HeartOffset className={styles.topheart} offset={"right"} />
			<HeartOffset className={styles.bottomheart} offset={"left"} />
			<div className={styles.image}>
				<div className={styles.bordercontainer}>
					<CurvedBorderVertical
						className={styles.border}
						rotation={180}
						fill={Colours.SUNSHINE_YELLOW}
					/>
				</div>
				<ProcessedImage
					src={imgSrc}
					dimensions="400x300"
					width={368}
					height={276}
					alt={imgAlt}
					loading={"lazy"}
				/>
			</div>
			<div className={styles.details}>
				<p className={styles.text}>{text}</p>
				<div className={styles.buttonwrapper}>
					<Button variant={"secondary"} url={url}>
						Sponsor Me
					</Button>
				</div>
			</div>
		</article>
	);
};

export default SponsorDogPromoCardFlatProps;
